import TrainerSignIn from "pages/LandingPages/TrainerSignIn/TrainerSignIn";

export default function TrainerSignInPage() {
  return <TrainerSignIn />;
}
